export default __webpack_public_path__ + "static/robert weissfeld-18b653ba9e4f5ab655186d11d7a4023a.webp";